import React, { FunctionComponent, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

//MUI
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

//Types
import { DCRecord } from "@/@types/lib/dataController";
import moment from "moment";

import { formats } from "@/lib/formats";

interface IDialogFooter {
  record?: DCRecord;
}

const DialogFooter: FunctionComponent<PropsWithChildren<IDialogFooter>> = (
  props
) => {
  const { t } = useTranslation();

  const { record } = props;

  const hgss_on = record?.hgss_modified_on
    ? moment
        .utc(record.hgss_modified_on as moment.Moment)
        .local()
        .format(formats.datetime)
    : null;
  const hgss_by = record?.hgss_modified_by
    ? (record.hgss_modified_by as string)
    : null;
  const hgss_label = record
    ? `${t("common.hgss")}: ` +
      (hgss_on && hgss_by
        ? `${t("common.modified_by")} ${hgss_by} ${t(
            "common.on_date"
          )} ${hgss_on}`
        : t("common.no_changes"))
    : null;

  const hps_on = record?.hps_modified_on
    ? moment
        .utc(record.hps_modified_on as moment.Moment)
        .local()
        .format(formats.datetime)
    : null;
  const hps_by = record?.hps_modified_by
    ? (record.hps_modified_by as string)
    : null;
  const hps_label = record
    ? `${t("common.hps")}: ` +
      (hps_on && hps_by
        ? `${t("common.modified_by")} ${hps_by} ${t(
            "common.on_date"
          )} ${hps_on}`
        : t("common.no_changes"))
    : null;

  ``;
  return (
    <DialogActions
      sx={{
        borderTopWidth: 1,
        borderTopStyle: "solid",
        borderTopColor: "#bdbdbd",
      }}
    >
      {hgss_label || hps_label ? (
        <Box
          sx={{
            flexShrink: 1,
            alignSelf: { xs: "flex-start", sm: "center" },
            ml: 4,
          }}
        >
          <Typography variant="caption" paragraph={true} sx={{ mb: 0 }}>
            {hgss_label}
          </Typography>
          <Typography variant="caption" paragraph={true} sx={{ mb: 0 }}>
            {hps_label}
          </Typography>
        </Box>
      ) : null}
      <div style={{ flex: "1 0 0" }} />
      {props.children}
    </DialogActions>
  );
};

export default DialogFooter;
